import { styled } from '../../Utilities';
import { getStyles } from './GroupedList.styles';
import { GroupedListBase } from './GroupedList.base';
export var GroupedList = styled(GroupedListBase, getStyles, undefined, {
    scope: 'GroupedList',
});
//# sourceMappingURL=GroupedList.js.map